
import { Vue, Component } from 'vue-property-decorator';
import { fromList } from '../data';
import Uploader from '@/components/next/Uploader.vue';
import { FileType } from '@/common/ts/enum';
import { Save } from '../api';
import { Input, Form, Select, Button, Modal } from 'ant-design-vue';
Vue.use(Input).use(Form).use(Select).use(Button).use(Modal);
@Component({
  components: {
    Uploader,
  },
})
export default class Home extends Vue {
  name = '';
  ModalText = '';
  visible = false;
  promiseCheck = false;
  form: any = [];
  presetFilesImages: any = [];
  saveSts: boolean = false;
  windowFlag: boolean = true;
  mounted() {
    const userAgentInfo = navigator.userAgent;
    const Agents = [
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod',
    ];
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        this.visible = true;
        this.ModalText = '请在电脑端打开报名';
        this.windowFlag = false;
        break;
      }
    }
    this.form = fromList;
    window.addEventListener('beforeunload', (e) => {
      const data = this.form;
      localStorage.setItem('0403yspxpc', JSON.stringify(data));
    });

    if (localStorage.getItem('0403yspxpc')) {
      this.form = JSON.parse(localStorage.getItem('0403yspxpc') as any);
      if (
        this.form[this.form.length - 1].value &&
        this.form[this.form.length - 1].value.length
      ) {
        this.form[this.form.length - 1].value.map((item: any) => {
          this.presetFilesImages.push({
            cover: item,
            path: item,
            type: FileType.Image,
          });
        });
      }
    }
    fromList.map((item, index) => {
      if (item.reg) {
        this.form[index].reg = item.reg;
      }
      if (item.reg1) {
        this.form[index].reg1 = item.reg1;
        this.form[index].reg2 = item.reg2;
      }
    });
  }
  handleOk() {
    this.visible = false;
  }
  async submit() {
    let data: any = {};
    for (let i = 0; i < this.form.length; i++) {
      if (this.form[i].key === 'email') {
        if (
          !this.form[i].reg1.test(this.form[i].value) ||
          !this.form[i].reg2.test(this.form[i].value)
        ) {
          this.visible = true;
          this.ModalText = this.form[i].tip;
          break;
        }
      } else if (
        this.form[i].required &&
        (!this.form[i].value ||
          (this.form[i].reg && !this.form[i].reg.test(this.form[i].value)))
      ) {
        this.visible = true;
        this.ModalText = this.form[i].tip;
        break;
      } else if (
        this.form[i].value &&
        this.form[i].reg &&
        !this.form[i].reg.test(this.form[i].value)
      ) {
        this.visible = true;
        this.ModalText = this.form[i].tip;
        break;
      }
      data[this.form[i].key] = this.form[i].value;
    }
    if (this.visible) {
      return;
    }
    if (!this.promiseCheck) {
      this.visible = true;
      this.ModalText = '请勾选个人承诺';
      return;
    }
    if (this.saveSts) {
      this.visible = true;
      this.ModalText = '请勿重复提交！';
      return;
    }

    (this.$refs.uploaderImage as any)[0]
      .uploadToOss()
      .then(async (res: any) => {
        this.saveSts = true;
        data.cover = res.join(',');
        this.form[this.form.length - 1].value = res;
        try {
          const reb: any = await Save(data);
          if (reb.code === 200) {
            this.visible = true;
            this.ModalText = '您已报名成功，请勿重复提交！';
            this.saveSts = false;
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          } else {
            this.visible = true;
            this.ModalText = reb.msg;
            this.saveSts = false;
          }
        } catch {
          this.saveSts = false;
        }
      });
  }
  beforeDestroy() {
    localStorage.setItem('0403yspxpc', JSON.stringify(fromList));
  }
}
